
export const REQUEST_SENDINVITATION= 'REQUEST_SENDINVITATION';
export const SENDINVITATION_RECEIVED = 'SENDINVITATION_RECEIVED';